@if (config(); as c) {
  <span
    class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-semibold border shrink-0"
    [class]="c.containerClass"
  >
    <span class="size-1.5 rounded-full" [class]="c.dotClass"></span>
    {{ c.label }}
  </span>
}
